import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { nav } from "@/content/copy";
import { scrollToId } from "@/lib/scroll";
import { Owl, TikTokButton } from "./primitives";

const go = (e, href, after) => {
  e.preventDefault();
  after?.();
  scrollToId(href);
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <header data-testid="nav-header" className={`ph-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="ph-container flex items-center justify-between h-16 sm:h-20">
        <a href="#top" onClick={(e) => go(e, "#top")} data-testid="brand-logo" className="ph-brand group" aria-label="Philosophiles, back to top">
          <Owl alt="" className="h-9 w-9 sm:h-10 sm:w-10 object-contain transition-transform duration-500 group-hover:-rotate-6" />
          <span className="font-display text-xl sm:text-2xl tracking-tight">Philosophiles</span>
        </a>
        <nav aria-label="Primary" className="hidden md:flex items-center gap-9">
          {nav.map((n) => (
            <a key={n.href} href={n.href} onClick={(e) => go(e, n.href)} data-testid={n.testId} className="ph-navlink">{n.label}</a>
          ))}
          <TikTokButton testId="nav-cta-follow-tiktok" variant="ghost" className="ph-btn-sm">Follow our journey</TikTokButton>
        </nav>
        <button type="button" className="grid md:hidden ph-iconbtn" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div id="mobile-menu" data-testid="mobile-menu" className="md:hidden ph-mobile-menu" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: 0.3 }}>
            <nav aria-label="Mobile" className="ph-container flex flex-col py-6 gap-1">
              {nav.map((n, i) => (
                <a key={n.href} href={n.href} onClick={(e) => go(e, n.href, () => setOpen(false))} data-testid={`mobile-${n.testId}`} className="ph-mobile-link">
                  <span className="text-sm tabular-nums opacity-80">0{i + 1}</span>{n.label}
                </a>
              ))}
              <TikTokButton testId="mobile-nav-cta-follow-tiktok" className="mt-6 self-start">Follow our journey</TikTokButton>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
